import {KNOB_WIDTH, knobCenter} from '@/components/ProgressTrack';

const LABEL_GAP = 8;

export interface LabelSizes {
    rowWidth: number;
    valueWidth: number;
    minWidth: number;
    maxWidth: number;
}

export interface ValueLabelLayout {
    left: number;
    isMinHidden: boolean;
    isMaxHidden: boolean;
}

/** The value label sits under the knob but never leaves the row, and hides the bound it reaches. */
export const getValueLabelLayout = (ratio: number, {rowWidth, valueWidth, minWidth, maxWidth}: LabelSizes) => {
    const left = Math.min(
        Math.max(knobCenter(ratio, rowWidth, KNOB_WIDTH) - valueWidth / 2, 0),
        Math.max(rowWidth - valueWidth, 0)
    );

    return {
        left,
        isMinHidden: left < minWidth + LABEL_GAP,
        isMaxHidden: left + valueWidth > rowWidth - maxWidth - LABEL_GAP,
    };
};
